import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import * as _ from 'lodash-es';

@Injectable({
  providedIn: 'root'
})
export class AddSchdmTemplateIdService {

  constructor(private http: HttpClient) { }

  /**
   * Get Templates Data
   * Matching AngularJS: ghostSchdmConfigFactory.getTemplatesData (action_code=3v1v6n)
   * Uses GET method with query string parameters
   */
  getTemplatesData(
    baseUrl: string,
    globalService: any,
    filterParams: any = {}
  ): Observable<any> {
    const baseUrlClean = baseUrl.endsWith('/') ? baseUrl.slice(0, -1) : baseUrl;
    const url = `${baseUrlClean}/loadJsonObject`;

    // Build query parameters matching AngularJS: filterParams + sso_id + screen_key + jcd_key
    let httpParams = new HttpParams()
      .set('action_code', '3v1v6n')
      .set('sso_id', globalService?.userSettingsData?.user?.sso_id || '')
      .set('screen_key', globalService?.globalParams?.screen_key || '')
      .set('jcd_key', filterParams.jcd_key || globalService?.globalParams?.jcd_key || 250);

    // Add filterParams to query string
    if (filterParams.tax_year) {
      httpParams = httpParams.set('tax_year', filterParams.tax_year);
    }
    if (filterParams.scenario) {
      httpParams = httpParams.set('scenario', filterParams.scenario);
    }

    // GET request with query string parameters (matching AngularJS method: "get", params: params)
    return this.http.get<any>(url, { params: httpParams, withCredentials: true });
  }

  /**
   * Save Template
   */
  saveTemplate(
    baseUrl: string,
    templateId: string,
    isExcluded: string,
    globalService: any,
    filterParams: any = {}
  ): Observable<any> {
    const baseUrlClean = baseUrl.endsWith('/') ? baseUrl.slice(0, -1) : baseUrl;
    const url = `${baseUrlClean}/saveJsonObject?action_code=ivb9cb`;

    // Build params matching AngularJS: filterParams + additional params
    // Start with merged globalParams and filterParams
    let params: any = _.merge({}, globalService?.globalParams || {}, filterParams);

    // Add required parameters (matching AngularJS service)
    params.sso_id = globalService?.userSettingsData?.user?.sso_id || '';
    params.jcd_key = globalService?.globalParams?.jcd_key || filterParams.jcd_key || 250;
    params.screen_key = globalService?.globalParams?.screen_key || filterParams.screen_key || '';
    
    // Template specific parameters
    params.template_id = templateId;
    params.is_excluded = isExcluded === 'Y' ? 'Y' : 'N';

    // Ensure tax_year and scenario are present from filterParams
    if (filterParams.tax_year) {
      params.tax_year = filterParams.tax_year;
    }
    if (filterParams.scenario) {
      params.scenario = filterParams.scenario;
    }

    // Encode as form data (matching AngularJS $http POST with data)
    const urlEncoded = new URLSearchParams();
    Object.keys(params).forEach(key => {
      const value = params[key];
      if (value !== undefined && value !== null) {
        urlEncoded.set(key, value.toString());
      }
    });

    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded'
    });

    return this.http.post<any>(url, urlEncoded.toString(), { headers, withCredentials: true });
  }
}
